import type { IconData } from '@stacksjs/iconify-core'

export const earSpeciality: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M8 18c0-8 6-15 16-15s16 7 16 15c0 8.555-5.444 12.876-7.864 14.374c-.672.416-1.127 1.138-1.173 1.927C30.548 41.434 26.665 45 21 45c-4.654 0-7.098-2.431-8.213-7\"/><path d=\"M15 20c0-4.571 3.5-9 9-9s8 4 8 8c0 4.443-2.997 6.851-4.755 7.882c-.722.424-1.23 1.177-1.3 2.011C25.575 33.342 23.406 35 21 35c-2.643 0-4.5-1.5-5-4.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default earSpeciality
